module.exports = __webpack_public_path__ + "static/media/snack_success.8cebfa10.svg";